interface VideoData {
  author: {
    nickname: string;
    avatar: string;
  };
  title: string;
  statistics: {
    playCount: number;
    likeCount: number;
    commentCount: number;
    shareCount: number;
  };
  thumbnail: string;
  videoUrl: string;
  videoUrlNoWatermark?: string;
  music?: {
    title: string;
    author: string;
  };
}

interface ApiResponse {
  success: boolean;
  data?: VideoData;
  error?: string;
}

document.addEventListener('DOMContentLoaded', function() {
    const urlInput = document.getElementById('urlInput') as HTMLInputElement;
    const getVideoBtn = document.getElementById('getVideoBtn') as HTMLButtonElement;
    const pasteBtn = document.getElementById('pasteBtn') as HTMLButtonElement;
    const loadingIndicator = document.getElementById('loadingIndicator') as HTMLDivElement;
    const errorMessage = document.getElementById('errorMessage') as HTMLDivElement;
    const errorText = document.getElementById('errorText') as HTMLSpanElement;
    const videoInfo = document.getElementById('videoInfo') as HTMLDivElement;

    const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

    pasteBtn.addEventListener('click', async () => {
        try {
            const text = await navigator.clipboard.readText();
            urlInput.value = text;
        } catch (err) {
            console.error('Failed to read clipboard:', err);
        }
    });

    let isProcessing = false;
    
    getVideoBtn.addEventListener('click', async () => {
        if (isProcessing) return;
        
        const input = urlInput.value.trim();
        if (!input) {
            showError('Vui lòng nhập URL hoặc nội dung share');
            return;
        }

        isProcessing = true;
        hideError();
        hideVideoInfo();
        showLoading();
        disableButton();

        try {
            const response = await fetch(`${API_BASE_URL}/api/video/info`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ input })
            });

            const result: ApiResponse = await response.json();

            if (result.success && result.data) {
                displayVideoInfo(result.data);
            } else {
                showError(result.error || 'Không thể lấy thông tin video');
            }
        } catch (error) {
            console.error('Error:', error);
            showError('Lỗi kết nối với server');
        } finally {
            hideLoading();
            enableButton();
            isProcessing = false;
        }
    });

    function displayVideoInfo(data: VideoData) {
        const authorAvatar = document.getElementById('authorAvatar') as HTMLImageElement;
        const authorName = document.getElementById('authorName') as HTMLHeadingElement;
        const videoTitle = document.getElementById('videoTitle') as HTMLParagraphElement;
        
        const playCount = document.getElementById('playCount') as HTMLParagraphElement;
        const likeCount = document.getElementById('likeCount') as HTMLParagraphElement;
        const commentCount = document.getElementById('commentCount') as HTMLParagraphElement;
        const shareCount = document.getElementById('shareCount') as HTMLParagraphElement;

        const videoPreview = document.getElementById('videoPreview') as HTMLVideoElement;

        authorAvatar.src = data.author.avatar;
        authorName.textContent = data.author.nickname;
        videoTitle.textContent = data.title;
        
        playCount.textContent = formatNumber(data.statistics.playCount);
        likeCount.textContent = formatNumber(data.statistics.likeCount);
        commentCount.textContent = formatNumber(data.statistics.commentCount);
        shareCount.textContent = formatNumber(data.statistics.shareCount);

        videoPreview.poster = data.thumbnail;
        
        const proxyUrl = `${API_BASE_URL}/api/video/proxy?url=${encodeURIComponent(data.videoUrl)}&preview=true`;
        videoPreview.src = proxyUrl;

        const downloadWithWatermark = document.getElementById('downloadWithWatermark') as HTMLButtonElement;
        const downloadNoWatermark = document.getElementById('downloadNoWatermark') as HTMLButtonElement;
        
        let currentVideoUrl = data.videoUrl;
        let currentNoWatermarkUrl = data.videoUrlNoWatermark || data.videoUrl;
        
        downloadWithWatermark.onclick = (e) => {
            e.preventDefault();
            window.open(`${API_BASE_URL}/redirect/video?url=${encodeURIComponent(currentVideoUrl)}`, '_blank');
        };
        
        downloadNoWatermark.onclick = (e) => {
            e.preventDefault();
            window.open(`${API_BASE_URL}/redirect/video?url=${encodeURIComponent(currentNoWatermarkUrl)}`, '_blank');
        };
        
        const directLinkInput = document.getElementById('directLinkInput') as HTMLInputElement;
        const copyLinkBtn = document.getElementById('copyLinkBtn') as HTMLButtonElement;
        
        directLinkInput.value = currentNoWatermarkUrl;
        
        directLinkInput.onclick = () => {
            directLinkInput.select();
        };
        
        copyLinkBtn.onclick = async () => {
            try {
                await navigator.clipboard.writeText(directLinkInput.value);
                const originalText = copyLinkBtn.innerHTML;
                copyLinkBtn.innerHTML = '<i class="fas fa-check"></i>';
                copyLinkBtn.classList.add('bg-green-500');
                setTimeout(() => {
                    copyLinkBtn.innerHTML = originalText;
                    copyLinkBtn.classList.remove('bg-green-500');
                }, 2000);
            } catch (err) {
                console.error('Failed to copy:', err);
            }
        };
        
        downloadWithWatermark.addEventListener('contextmenu', (e) => {
            e.preventDefault();
            directLinkInput.value = currentVideoUrl;
        });
        
        downloadNoWatermark.addEventListener('contextmenu', (e) => {
            e.preventDefault();
            directLinkInput.value = currentNoWatermarkUrl;
        });
        
        const downloadDataUri = document.getElementById('downloadDataUri') as HTMLButtonElement;
        const downloadBlank = document.getElementById('downloadBlank') as HTMLButtonElement;
        
        downloadDataUri.onclick = (e) => {
            e.preventDefault();
            window.open(`${API_BASE_URL}/redirect/video-data?url=${encodeURIComponent(currentNoWatermarkUrl)}`, '_blank');
        };
        
        downloadBlank.onclick = (e) => {
            e.preventDefault();
            window.open(`${API_BASE_URL}/redirect/video-blank?url=${encodeURIComponent(currentNoWatermarkUrl)}`, '_blank');
        };

        const musicInfo = document.getElementById('musicInfo') as HTMLDivElement;
        const musicTitle = document.getElementById('musicTitle') as HTMLParagraphElement;

        if (data.music) {
            musicInfo.classList.remove('hidden');
            musicTitle.textContent = `${data.music.title} - ${data.music.author}`;
        } else {
            musicInfo.classList.add('hidden');
        }

        videoInfo.classList.remove('hidden');
    }

    function formatNumber(num: number): string {
        if (num >= 1000000) {
            return (num / 1000000).toFixed(1) + 'M';
        } else if (num >= 1000) {
            return (num / 1000).toFixed(1) + 'K';
        }
        return num.toString();
    }

    function showLoading() {
        const searchIcon = document.getElementById('searchIcon') as HTMLElement;
        const buttonText = document.getElementById('buttonText') as HTMLSpanElement;
        
        searchIcon.className = 'fas fa-spinner fa-spin mr-2';
        buttonText.textContent = 'Đang lấy thông tin...';
        
        loadingIndicator.classList.remove('hidden');
    }

    function hideLoading() {
        const searchIcon = document.getElementById('searchIcon') as HTMLElement;
        const buttonText = document.getElementById('buttonText') as HTMLSpanElement;
        
        searchIcon.className = 'fas fa-search mr-2';
        buttonText.textContent = 'Lấy thông tin video';
        
        loadingIndicator.classList.add('hidden');
    }

    function showError(message: string) {
        errorText.textContent = message;
        errorMessage.classList.remove('hidden');
    }

    function hideError() {
        errorMessage.classList.add('hidden');
    }

    function hideVideoInfo() {
        videoInfo.classList.add('hidden');
    }

    function disableButton() {
        getVideoBtn.disabled = true;
        getVideoBtn.classList.add('opacity-50', 'cursor-not-allowed');
    }

    function enableButton() {
        getVideoBtn.disabled = false;
        getVideoBtn.classList.remove('opacity-50', 'cursor-not-allowed');
    }

    urlInput.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
            getVideoBtn.click();
        }
    });

    function performUrlExtraction(autoFetch = false) {
        const content = urlInput.value.trim();
        if (!content) return;

        const extractedUrl = extractDouyinUrl(content);
        if (extractedUrl && extractedUrl !== content) {
            urlInput.value = extractedUrl;
            
            if (autoFetch) {
                getVideoBtn.click();
            } else {
                urlInput.style.borderColor = '#10b981';
                setTimeout(() => {
                    urlInput.style.borderColor = '';
                }, 800);
            }
        }
    }

    urlInput.addEventListener('blur', () => performUrlExtraction(false));

    let pasteTimeout: ReturnType<typeof setTimeout>;
    urlInput.addEventListener('paste', () => {
        clearTimeout(pasteTimeout);
        pasteTimeout = setTimeout(() => performUrlExtraction(true), 50);
    });

    function extractDouyinUrl(text: string): string | null {
        if (/^https?:\/\/[vwm]\.?douyin\.com/.test(text.trim())) {
            return text.trim();
        }

        const quickPatterns = [
            /https?:\/\/v\.douyin\.com\/[A-Za-z0-9_-]+\/?/,
            /https?:\/\/m\.douyin\.com\/share\/video\/\d+/,
            /https?:\/\/(?:www\.)?douyin\.com\/video\/\d+/,
            /https?:\/\/(?:www\.)?iesdouyin\.com\/share\/video\/\d+/
        ];

        for (const pattern of quickPatterns) {
            const match = text.match(pattern);
            if (match) {
                return match[0].replace(/[\s,，。！!？?）)】》]+$/, '');
            }
        }

        const urls = text.match(/https?:\/\/[^\s]+/g);
        if (urls) {
            for (const url of urls) {
                if (url.includes('douyin')) {
                    return url.replace(/[\s,，。！!？?）)】》]+$/, '');
                }
            }
        }

        return null;
    }
});